import * as signalR from '@microsoft/signalr'
import URL from 'src/api/url/api'

const connection = new signalR.HubConnectionBuilder()
  .configureLogging(signalR.LogLevel.Error)
  .withUrl(URL.SOCKET_URL, {
    skipNegotiation: true,
    transport: 1,
  })
  .withAutomaticReconnect()
  .build()

let startPromise = null

/**
 * Resolves to true once the hub is connected, false if it could not connect.
 * Safe to call concurrently: repeated calls share a single start attempt
 * instead of throwing while the connection is still in 'Connecting'.
 */
const startConnection = async () => {
  if (connection.state === 'Connected') {
    return true
  }

  if (!startPromise) {
    startPromise = connection
      .start()
      .then(() => true)
      .catch(err => {
        console.error('SignalR connection failed:', err.toString())

        return false
      })
      .finally(() => {
        startPromise = null
      })
  }

  return startPromise
}

/**
 *
 * @param {*} cardId
 * @param {*} callback
 */
const addMessageReceivedListener = (cardId, callback) => {
  connection.on('ReceiveMessage', callback)
}

/**
 *
 * @param {*} callback
 */
const addCourseCreationMessageReceivedListener = callback => {
  connection.on('ReceiveMessage', callback)
}

/**
 * Detaches a listener registered above. The connection is shared across the
 * whole app, so a listener that is never removed stays attached for the life
 * of the page and fires again on every later broadcast.
 *
 * @param {*} callback
 */
const removeMessageReceivedListener = callback => {
  connection.off('ReceiveMessage', callback)
}

export {
  startConnection,
  addMessageReceivedListener,
  addCourseCreationMessageReceivedListener,
  removeMessageReceivedListener,
}
